import { OutgoingFaxTask } from "./orchestrator";
import { IntakeDocument } from "./intake";
import { IntakeOrder } from "./intake";
import { OrderInfo } from "./orderInfo";

export class AuditEntry {
  constructor(entry, dateAdapter) {
    this.id = entry.id;
    this.timestamp = entry.timestamp;
    this.date = new Date(this.timestamp);
    this.user = entry.user;
    this.userNote = entry.userNote;
    this.logEntry = entry.logEntry;
    this.outgoingFaxTask = entry.outgoingFaxTask ? new OutgoingFaxTask(entry.outgoingFaxTask) : null;
    this.intakeDocument = entry.intakeDocument ? new IntakeDocument(entry.intakeDocument, dateAdapter) : null;
    this.intakeOrder = entry.intakeOrder ? new IntakeOrder(entry.intakeOrder, dateAdapter) : null;
    this.incomingFax = entry.incomingFax;
    this.orderInfo = entry.orderInfo ? new OrderInfo(entry.orderInfo) : null;
  }
}
